import { Data } from './data';

export class AllData {
    data: Data;
    success: boolean;
}
